import React, {Component} from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { startLoading, endLoading } from '../../actions/loadingActions';
import { updateCaso } from '../../actions';
import {renderTextArea} from '../forms/newcaso/Fields'

class PartialModal extends Component{
    onSubmit(data){
        this.props.updateCaso({
            id: this.props.casoId,
            partial_delivery: data.partial_delivery
        })
        this.props.startLoading();
        this.props.toggler();
    }
    render(){
        const { handleSubmit } = this.props;
        return(
            <Modal className="modal-lg modal-dialog-centered" isOpen={this.props.show} toggle={this.props.toggler}>
                <ModalHeader><span>Entrega parcial</span></ModalHeader>
                <ModalBody>
                    <form ref="formPartial" className="modal-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                        <div className="form-row">
                            <Field
                                name="partial_delivery"
                                col="col-md-12"
                                component={renderTextArea}
                            />
                        </div>
                    </form>

                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={this.props.toggler}>Cancelar</Button>
                    <Button color="primary" onClick={handleSubmit(this.onSubmit.bind(this))}>Enviar</Button>{' '}
                </ModalFooter>
            </Modal>

        )
    }
}
function mapStateToProps(state) {
    return {
        loading: state.loading,
        partialDelivery: state.caso.partial_delivery,
        initialValues: { partial_delivery: state.caso.partial_delivery },
    };
}

PartialModal = reduxForm({
    form: 'formPartial',
})(PartialModal);



export default PartialModal = connect(mapStateToProps, {
    updateCaso,
    startLoading,
    endLoading
})(PartialModal);


// WEBPACK FOOTER //
// ./resources/assets/js/components/viewer/PartialModal.jsx